import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InfoComponent } from './info.component';
import { ModalOpenerModule } from '../modal-opener/modal-opener.module';
import { UtilitiesModule } from '../utilities/utilities.module';



@NgModule({
  declarations: [InfoComponent],
  imports: [
    CommonModule,
    ModalOpenerModule,
    UtilitiesModule
  ],
  exports: [InfoComponent]
})
export class InfoModule { }
